/* eslint-disable max-lines-per-function */
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/components/Mitarbeiter';
import { RowDivider } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/components/RowDivider';
import { Station } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/components/Station';
import { data } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/data';
import { CSSProperties, useRef } from 'react';
import { KalenderWoche } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/components/KalenderWoche';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

type StyleProps = CSSProperties & {
  '--col-start': CSSProperties['gridColumnStart'];
};

type StylePropsGrid = CSSProperties & {
  '--col-count': CSSProperties['gridTemplateColumns'];
};

export function Kalender({ jahr }: { jahr: string }) {
  const weeksInYear = dayjs(`${jahr}-01-01`).isoWeeksInYear();
  const ref = useRef<HTMLDivElement | null>(undefined);

  return (
    <div className="w-full relative">
      <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10" />
      <div className="overflow-x-auto">
        <div
          ref={ref}
          className={`grid grid-cols-[1fr_repeat(var(--col-count),8px)] md:grid-cols-[180px_repeat(var(--col-count),16px)] w-fit h-full`}
          style={
            {
              '--col-count': weeksInYear * 7,
            } as StylePropsGrid
          }>
          <div className="sticky left-0 bg-white z-10 row-start-1 border-r border-solid border-neutrals-N200"></div>
          {Array.from({ length: weeksInYear }, (_, i) => {
            const startOfWeek = dayjs()
              .year(parseInt(jahr))
              .isoWeek(i + 1)
              .startOf('isoWeek');

            const endOfWeek = dayjs()
              .year(parseInt(jahr))
              .isoWeek(i + 1)
              .endOf('isoWeek');

            const isCurrentWeek =
              dayjs().get('year').toString() === jahr &&
              dayjs().isoWeek() === i + 1;

            return (
              <div
                key={i}
                className={`col-start-[var(--col-start)] col-span-7 row-start-1 p-2`}
                style={
                  {
                    '--col-start': i * 7 + 2,
                  } as StyleProps
                }>
                <KalenderWoche
                  isCurrentWeek={isCurrentWeek}
                  startOfWeek={startOfWeek.format('DD.MM')}
                  endOfWeek={endOfWeek.format('DD.MM')}
                  index={i}
                  gridRef={ref}
                />
              </div>
            );
          })}
          <RowDivider />
          {data.map((mitarbeiter) => {
            return (
              <>
                <Mitarbeiter mitarbeiter={mitarbeiter} />
                {mitarbeiter.stationen
                  .filter(
                    (station) =>
                      dayjs(station.von).get('year').toString() === jahr &&
                      dayjs(station.bis).get('year').toString() === jahr,
                  )
                  .map((station) => (
                    <Station key={station.id} station={station} />
                  ))}
                <RowDivider />
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
}
